(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["checkout-diagnosis-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('checkout-diagnosis-modal')) {
    class CheckoutDiagnosisModal extends HTMLElement {
      static storageKey = 'checkout-diagnosis-dismissed';

      constructor() {
        super();

        this.classes = {
          active: 'is-active',
          bodyClass: 'checkout-diagnosis-modal--open',
        };

        this.overlay = this.querySelector('.checkout-diagnosis-modal__overlay');
        this.panel = this.querySelector('.checkout-diagnosis-modal__panel');

        this.onKeyDown = this.onKeyDown.bind(this);
        this.onModalClick = this.onModalClick.bind(this);
        this.onStopPropagation = (event) => event.stopPropagation();
        this.openDelayMs = 120000;
        this.remindDelayMs = 190000;
        this.openTimeoutId = null;
      }

      scheduleOpen(delayMs) {
        this.clearOpenTimeout();
        this.openTimeoutId = window.setTimeout(() => this.open(), delayMs);
      }

      clearOpenTimeout() {
        if (this.openTimeoutId !== null) {
          window.clearTimeout(this.openTimeoutId);
          this.openTimeoutId = null;
        }
      }

      isDismissedForSession() {
        try {
          return sessionStorage.getItem(CheckoutDiagnosisModal.storageKey) === 'true';
        } catch (error) {
          return false;
        }
      }

      dismissForSession() {
        try {
          sessionStorage.setItem(CheckoutDiagnosisModal.storageKey, 'true');
        } catch (error) {
          /* sessionStorage unavailable */
        }

        this.clearOpenTimeout();
      }

      connectedCallback() {
        if (document.querySelector('checkout-diagnosis-modal[data-mounted]') && !this.hasAttribute('data-mounted')) {
          this.remove();
          return;
        }

        this.setAttribute('data-mounted', '');

        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
        }

        this.addEventListener('click', this.onStopPropagation);
        this.addEventListener('click', this.onModalClick);
        this.overlay?.addEventListener('click', (event) => event.stopPropagation());

        if (!this.isDismissedForSession()) {
          this.scheduleOpen(this.openDelayMs);
        }
      }

      disconnectedCallback() {
        this.clearOpenTimeout();
        this.removeEventListener('click', this.onStopPropagation);
        this.removeEventListener('click', this.onModalClick);
        this.close();
      }

      onModalClick(event) {
        const button = event.target.closest(
          '[data-checkout-diagnosis-yes], [data-checkout-diagnosis-no], [data-checkout-diagnosis-remind]'
        );
        if (!button) {
          return;
        }

        this.onButtonClick(button);
      }

      onButtonClick(button) {
        if (button.hasAttribute('data-checkout-diagnosis-yes')) {
          this.dismissForSession();
          this.close();
          this.openRevievePopup();
          return;
        }

        if (button.hasAttribute('data-checkout-diagnosis-remind')) {
          this.close();
          this.scheduleOpen(this.remindDelayMs);
          return;
        }

        this.dismissForSession();
        this.close();
      }

      openRevievePopup() {
        if (window.Revieve && Revieve.API && typeof Revieve.API.show === 'function') {
          Revieve.API.show();
          return;
        }

        const revieveButton = document.getElementById('revieve-button');
        if (revieveButton) {
          revieveButton.click();
        }
      }

      onKeyDown(event) {
        if (event.key === 'Escape' || event.code === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
        }

        if (event.key === 'Tab') {
          this.trapTab(event);
        }
      }

      open() {
        if (this.isDismissedForSession() || this.classList.contains(this.classes.active)) {
          return;
        }

        setScrollbarWidth();
        this.classList.add(this.classes.active);
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add(this.classes.bodyClass);
        document.addEventListener('keydown', this.onKeyDown, true);

        trapFocus(this, this.panel);
      }

      close() {
        if (!this.classList.contains(this.classes.active)) {
          return;
        }

        this.classList.remove(this.classes.active);
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove(this.classes.bodyClass);
        document.removeEventListener('keydown', this.onKeyDown, true);
        removeTrapFocus();
      }

      trapTab(event) {
        const focusableElements = this.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        const focusable = Array.from(focusableElements).filter(
          (element) => !element.disabled && element.offsetParent !== null
        );

        if (!focusable.length) {
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    customElements.define('checkout-diagnosis-modal', CheckoutDiagnosisModal);
  }
  } catch(e) { console.error(e); }
})();

})();
